<template>
  <path
    d="M17 1.01024L7 1.00024C5.9 1.00024 5 1.90024 5 3.00024V21.0002C5 22.1002 5.9 23.0002 7 23.0002H17C18.1 23.0002 19 22.1002 19 21.0002V3.00024C19 1.90024 18.1 1.01024 17 1.01024ZM17 19.0002H7V5.00024H17V19.0002Z"
  />
</template>
